export default __webpack_public_path__ + "static/media/heartYouSoMuch.b224e0ad.webp";